import SiteHeader from '@/components/layout/SiteHeader/SiteHeader';
import SiteFooter from '@/components/layout/SiteFooter/SiteFooter';
import ReportWorkspace from '@/components/shirabe/ReportWorkspace/ReportWorkspace';
import { usePageSeo } from '@/hooks/usePageSeo';

// C 向け (一般の方) の立地レポート画面。本体は ReportWorkspace。PDF 出力は B 向け機能なのでここには無い。
export default function Shirabe() {
  // 調査結果 (/report?lat=…&lon=…) は地点ごとに無数にあるので検索には載せない。入口は LP とサンプル。
  usePageSeo({ noindex: true });
  return (
    <ReportWorkspace
      renderHeader={({ onHome }) => <SiteHeader variant="app" onHome={onHome} />}
      footer={<SiteFooter />}
      hero={{ eyebrow: '立地レポート', title: '調べたい土地の住所を、入れてみてください。' }}
    />
  );
}
